module.exports = __webpack_public_path__ + "static/media/33.d5123b2f.jpeg";